<template>
  <div class="login u-absolute0">
    <div class="loginForm u-absoluteCenter u-cf">
      <div class="u-fl">
        <img src="../../assets/img/bg2.png" alt="">
      </div>
      <div class="u-fr">
        <div class="title">
          <img src="../../assets/img/logo.png" alt="">
          <span>官网后台管理</span>
        </div>
        <el-form
          ref="form"
          label-position="right"
          label-width="0"
          :model="form"
          :rules="formRules">
          <el-form-item label="" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="用户名/手机号"
              maxlength="20"
              clearable>
            </el-input>
            <span class="iconfont icon-user"></span>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              v-model.trim="form.password"
              placeholder="密码"
              maxlength="20"
              show-password>
            </el-input>
            <span class="iconfont icon-password"></span>
          </el-form-item>
        </el-form>
        <el-button
          type="primary" class="loginBtn"
          @click="onClickLogin"
          :loading="confirmBtnDis">
          登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { login } from '@/api/user';
  
  export default {
    name: 'login',
    inject: ['path', 'myMessage'],
    data () {
      return {
        confirmBtnDis: false,
        form: {
          name: '',
          password: ''
          // hyb, 123123
        },
        formRules: {
          name: [
            { required: true, message: '不能为空' }
          ],
          password: [
            { required: true, message: '不能为空' }
          ]
        }
      };
    },
    methods: {
      onClickLogin () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // this.$store.dispatch('setName', {
            //   name: this.form.name,
            //   jwt: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxLCJ1c2VyX2tleSI6ImUxMGRmN2JjZDg0NTExZTlhYWRmMDAwYzI5ZTFmMDg0Iiwib3JnX2lkIjoxLCJvcmdfa2V5IjoiZTEwZGY3YmFkODQ1MTFlOWFhZGYwMDBjMjllMWYwODQiLCJ1c2VyX3R5cGUiOjEsInJvbGVfaWQiOiIiLCJyb2xlX2NvZGUiOiIifQ.E430-F9s87naMqR_sBzQEFd214MUJ0LjzxoAEnOdLC4'
            // })
            //   .then(() => {
            //     this.$router.push(this.path.Index());
            //   });

            this.confirmBtnDis = true;
            login({ user_code: this.form.name, password: this.form.password })
              .then(res => {
                this.$store.dispatch('setName', { name: this.form.name, jwt: res.data.jwt })
                  .then(() => {
                    this.$router.push(this.path.Index());
                  });
              })
              .finally(() => {
                this.confirmBtnDis = false;
              });
            console.log(this.$router);
          }
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "@/styles/_variables.scss";
  
  .login {
    min-width: 1000px;
    min-height: 500px;
    background: url('../../assets/img/bg.jpg') 0 0 no-repeat;
    background-size: cover;
    
    .loginForm {
      position: fixed !important;
      width: 1000px;
      background: white;
      box-shadow: 0 0 8px #008ecc;
      border-radius: 4px;
      
      > div {
        &:first-child {
          width: 550px;
          height: 500px;
          
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        
        &:last-child {
          width: 350px;
          margin-right: 50px;
        }
      }
      
      .title {
        margin-top: 60px;
        font-size: 18px;
        font-weight: 500;
        line-height: 30px;
        
        img {
          width: 30px;
          float: left;
          margin-right: 8px;
        }
      }
      
      .iconfont {
        position: absolute !important;
        top: 1px;
        left: 8px;
        color: #30b7ff;
      }
    }
    
    .el-form {
      margin-top: 70px;
      
      .el-form-item {
        margin-bottom: 30px;
      }
      
      .el-form-item__content {
        line-height: 40px;
      }
      
      .el-input__inner {
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        padding-left: 30px;
      }
    }
    
    .loginBtn {
      width: 100%;
      height: 40px;
      font-size: 14px;
      margin-top: 40px;
      background: #30b7ff;
    }
  }
</style>
